import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z
  .object({
    view: z.string().optional(),
    paidStep: z.string().optional(),
    checkout: z.string().optional(),
    returnView: z.string().optional(),
    cid: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute('/$locale/')({
  validateSearch: searchSchema,
});
